<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Cari Entegrasyon</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn slot="activator" @click="CancelEntegre()" flat>
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down">Entegre Kaldır</span>
                </span>
                <v-icon right>cancel_schedule_send</v-icon>
              </v-btn>
              <span>Entegre Kaldır</span>
            </v-tooltip>

            <v-tooltip bottom>
              <v-btn slot="activator" @click.native="preViewDialog = true" flat>
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down">
                    {{ $t("Previewing") }}
                  </span>
                </span>
                <v-icon right>preview</v-icon>
              </v-btn>
              <span> {{ $t("Previewing") }} </span>
            </v-tooltip>

            <v-tooltip bottom>
              <v-btn slot="activator" @click.native="entegreDialog = true" flat>
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down">
                    {{ $t("Integrate") }}
                  </span>
                </span>
                <v-icon color="white" right>send</v-icon>
              </v-btn>
              <span> {{ $t("Integrate") }} </span>
            </v-tooltip>
          </v-toolbar>
        </v-flex>

        <v-container fluid>
          <v-form ref="formEntegre" v-model="validEntegre" lazy-validation>
            <v-card class="pa-2 elevation-3">
              <v-layout row wrap>
                <v-flex xs12 sm6 md6>
                  <v-select
                        :items="this.credentials.Sirketler"
                        item-text="SirketAdi"
                        item-value="SirketKodu"
                        label="Cari Firması"
                        v-model="seciliCariFirma"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                        v-on:change="getExpenseCenters"
                      ></v-select> 
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-select
                        :items="this.credentials.MuhasebeSirketler"
                        item-text="CompanyShortName"
                        item-value="CompanyID"
                        label="Muhasebe Firması"
                        v-model="seciliMuhasebeFirma"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                        
                      ></v-select> 
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md6>
                      <tarihim
                        :etiket="$t('Starting-Date')"
                        v-model="searchParams.StartDate"
                        v-bind:defaultvalue="'ok'"
                      ></tarihim>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <tarihim
                        :etiket="$t('Finishing-Date')"
                        v-model="searchParams.EndDate"
                        v-bind:defaultvalue="'ok'"
                      ></tarihim>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6 md8>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md6>
                      <v-select
                        v-model="searchParams.IntegrationType"
                        @change="checkValueVisible()"
                        :items="itemCariEntegre"
                        label="Entegrasyon Tipi"
                        item-text="text"
                        item-value="value"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <merkez v-model="CenterCode" :rules="[(v) => !!v || $t('Mandatory-Areas')]"> </merkez>
                    </v-flex>
                   
                  </v-layout>
                </v-flex>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md4 v-if="EvrakTipView">
                      <v-autocomplete clearable :items="EvrakTipi1" hide-details="" v-bind="EvrakTipi1" item-text="Title"
                          item-value="Evrakkod"  v-model="searchParams.DocTypeCode"
                          :label="$t('Document-Type')" placeholder="Tümü"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="!TahsilView">
                      <fistipi v-model="RecieptType" :rules="rulesCari"></fistipi>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete :items="masrafmerkezi" hide-details="" :label="$t('Expense-Center-v2')" item-text="Title"
                        clearable v-model="ExpenseCenter" item-value="Code"  placeholder="Tümü"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 md4 v-if="TahsilView">
                      <catimuhasebekodu
                        v-model="CashAccountingCodeID"
                        :controlValue="CashAccountingCodeID"
                        :companyID="credentials.MuhasebeSirketNo"
                        :text="$t('Accounting-Code')"
                        @validateCheck="checkAccoutingValidate()"
                        :rules="rulesTahsil"
                      >
                      </catimuhasebekodu>
                    </v-flex>
                  </v-layout>
               
            
              </v-layout>
            </v-card>
          </v-form>
        </v-container>
      </v-layout>
    </v-card>

    <v-layout row justify-center>
      <v-dialog v-model="preViewDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline primary white--text">
            {{ $t("Integration-Bill") }}
          </v-card-title>
          <v-card-text>
            <blockquote>
              <span style="color: red">
                {{
                  $t("Records-will-not-transferred-Accounting-for-previewing")
                }}
              </span>
            </blockquote>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="preViewDialog = false">{{
              $t("cancel_button")
            }}</v-btn>
            <v-btn color="primary" flat @click="getPreeView()">{{
              $t("Find")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="entegreDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline primary white--text">
            {{ $t("Integration-Bill") }}
          </v-card-title>
          <v-card-text>
            <blockquote>
              <span style="color: red">
                {{ $t("Records-will-transferred-Accounting-Integration") }}
              </span>
            </blockquote>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="entegreDialog = false">{{
              $t("cancel_button")
            }}</v-btn>
            <v-btn color="primary" flat @click="getEntegreView()">{{
              $t("Find")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row v-show="dialogTemplate" justify-center>
      <v-card>
        <v-card-title class="headline">{{ $t("Result") }}</v-card-title>
        <v-card-text>
          <iframe
            scrolling="yes"
            id="result"
            src=""
            height="600"
            width="1200"
            type="application/html"
          >
          </iframe>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import merkez from "@/components/app/muhasebe/comp/merkez.vue";
import fistipi from "@/components/app/muhasebe/comp/fistipi.vue";
import catimuhasebekodu from "@/components/app/muhasebe/comp/catimuhasebekodu.vue";

export default {
  data() {
    return {
      masrafmerkezi: [],
      ExpenseCenter:null,
      EvrakTipi1: [],
      seciliCariFirma:null,
      seciliMuhasebeFirma:null,
      templateHint: "",
      RecieptType: null,
      resultDialog: true,
      entegreDialog: false,
      dialogTemplate: false,
      itemCariEntegre: [
        {
          text: "Cari Hareketler",
          value: 0,
        },
        {
          text: "Tahsil Hareketler",
          value: 1,
        },
        {
          text: "Tediye Hareketler",
          value: 2,
        },
      ],
      itemsTicketIntegration: [
        {
          text: this.$t("Bill"),
          value: 0,
        },
        {
          text: this.$t("Not-invoiced-Ones"),
          value: 1,
        },
        {
          text: this.$t("Refund"),
          value: 2,
        },
      ],
      headerTemplate: [
        {
          text: "",
          value: "",
        },
        {
          text: this.$t("Template-Name"),
          value: "TemplateName",
        },
        {
          text: this.$t("Template-Type"),
          value: "TemplateType",
        },
        {
          text: this.$t("Flight-Type"),
          value: "TemplateTicketType",
        },
        {
          text: this.$t("Process"),
        },
      ],
      itemsTemplate: [],
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      CenterCode: null,
      searchParams: {
        UserID: 0,
        PreView: false,
        StartDate: null,
        EndDate: null,
        IntegrationType: 0,
        SourceType: 2,
        TicketType: false,
        SourceCompanyID: 0,
        AccountingCompanyID: 0,
        TemplateID: 0,
        RecieptType: 0,
        AccountingCenter: 0,
        CashAccountingCodeID: 0,
        DocTypeCode:'',
        CostCenterCode:"",
        CompanyID:null
      },
      ticketType: [
        {
          text: this.$t("Domestic-Line"),
          value: "0",
        },
        {
          text: this.$t("International-Line"),
          value: "2",
        },
      ],
      templateType: [
        {
          text: this.$t("Sales"),
          value: "0",
        },
        {
          text: this.$t("Cost"),
          value: "1",
        },
        {
          text: this.$t("Refund"),
          value: "2",
        },
      ],
      CashAccountingCodeID: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
      validEntegre: true,
      preViewDialog: false,
      addDialog: false,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      templateDeleteId: 0,
      entTypeOther: false,
      entTypeRefund: false,
      TahsilView: false,
      EvrakTipView:true,
      rulesTahsil : [(v) => !!v || this.$t('Mandatory-Areas')],
      rulesCari : [(v) => !!v || this.$t('Mandatory-Areas')],
    };
  },
  methods: {
    getExpenseCenters(){

var params={
  SourceCompanyID :this.seciliCariFirma,
}
this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
    headers: {
      'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
  }).then((response) => {
    this.masrafmerkezi = response.body
  }, (response) => {
    if (response.status === 0) {
      this.text1 = 'Service Unavailable-Masraf Merkezi'
      this.snackbar = true
    } else {
      this.text1 = 'Service Unavailable-Masraf Merkezi'
      this.snackbar = true
    }
  })
},
    getEvrakTipi(){
     
     
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          CompanyCode: credentials.SirketKodu
        }
      this.$http.post(auth.API_URL + 'api/doctype/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.EvrakTipi1 = response.body;
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Evrak Tipi'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Evrak Tipi'
            this.snackbar = true
          }
        })
       
    },
    checkValueVisible() {
      
      switch (this.searchParams.IntegrationType) {
       
        case 0:

          this.EvrakTipView=true;
          this.TahsilView = false;
          this.rulesCari = [(v) => !!v || this.$t('Mandatory-Areas')];
          this.rulesTahsil = [];
          break;
        default:
          this.EvrakTipView=false;
          this.TahsilView = true;
          this.rulesTahsil = [(v) => !!v || this.$t('Mandatory-Areas')];
          this.rulesCari = [];
          break;
      }
    },
    checkAccoutingValidate() {
      this.CashAccountingCodeID.CodeID = 0;
    },
    setTemplateHint() {
      var template = this.itemsTemplate.find(
        (x) => x.TemplateID == this.searchParams.TemplateID
      );
      var result = this.templateType.find(
        (y) => y.value == template.TemplateType
      );

      switch (result.value) {
        case "0":
          this.searchParams.IntegrationType = "0";
          this.entTypeOther = false;
          this.entTypeRefund = true;
          break;
        case "1":
          this.searchParams.IntegrationType = "1";
          this.entTypeOther = false;
          this.entTypeRefund = true;
          break;
        case "2":
          this.searchParams.IntegrationType = "2";
          this.entTypeOther = true;
          this.entTypeRefund = false;
          break;
        case "3":
          this.searchParams.IntegrationType = "3";
          this.entTypeOther = true;
          this.entTypeRefund = false;
          break;
        default:
          break;
      }
      this.templateHint = "Seçtiğiniz şablon " + result.text + " şablonudur";
    },
    CancelEntegre() {
      if (this.$refs.formEntegre.validate()) {
        var bastarih = new Date(this.searchParams.StartDate);
        var bittarih = new Date(this.searchParams.EndDate);
        if (this.searchParams.DocTypeCode==null)
        {
          this.searchParams.DocTypeCode="";
        }
        if (bastarih <= bittarih) {
          this.loadingvmodel = true;

          if (this.ExpenseCenter==null || this.ExpenseCenter=="undefined")
        {
          this.searchParams.CostCenterCode="";
        }
        else
        {
          this.searchParams.CostCenterCode=this.ExpenseCenter;
        }

          var cancelParams = {
            ID: 0,
            SourceType: 2,
            IntegrationType: this.searchParams.IntegrationType,
            SourceCompanyID: this.seciliCariFirma,
            ActionDate: null,
            RecieptID: 0,
            TicketID: null,
            SaveDate: null,
            SaveUserID: null,
            Removed: false,
            RemovedDate: null,
            TemplateID: this.searchParams.TemplateID,
            StartDate: this.searchParams.StartDate,
            EndDate: this.searchParams.EndDate,
            RemovedUserID: this.credentials.UserID,
            AccountingCompanyID: this.seciliMuhasebeFirma,
            DocTypeCode:this.searchParams.DocTypeCode,
            CostCenterCode:this.searchParams.CostCenterCode,
            CompanyID:this.credentials.MuhasebeSirketNo
          };

          this.$http
            .post(
              auth.API_URL +
                "api/AccountingIntegrations/IntegrationFollowUpRemove",
              cancelParams,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                this.loadingvmodel = false;
                if (response.body.Status) {
                   this.text1 = this.$t(response.body.ResponseMessage);
                  this.snackbar = true;
                } else {
                   this.text1 = this.$t(response.body.ResponseMessage);
                  this.snackbar = true;
                }
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable-IntegrationFollowUpRemove";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                } else {
                  this.text1 = "Service Unavailable-IntegrationFollowUpRemove";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                }
              }
            );
        } else {
          this.text1 = this.$t("start-date-cannot-greater-than-end-date");
          this.snackbar = true;
        }
      }
    },
    getEntegreView() {
      if (this.$refs.formEntegre.validate()) {
        var bastarih = new Date(this.searchParams.StartDate);
        var bittarih = new Date(this.searchParams.EndDate);
        if (this.searchParams.DocTypeCode==null)
        {
          this.searchParams.DocTypeCode="";
        }
        if (this.ExpenseCenter==null || this.ExpenseCenter=="undefined")
        {
          this.searchParams.CostCenterCode="";
        }
        else
        {
          this.searchParams.CostCenterCode=this.ExpenseCenter;
        }
        if (bastarih <= bittarih) {
          this.loadingvmodel = true;

          this.loadingvmodel = true;
          this.searchParams.AccountingCompanyID =this.seciliMuhasebeFirma;
          this.searchParams.UserID = this.credentials.UserID;
          this.searchParams.AccountingCenter = this.CenterCode.ID;
          this.searchParams.CompanyID=this.credentials.MuhasebeSirketNo;
          if (this.RecieptType!=null)
        {
          this.searchParams.RecieptType = this.RecieptType.ID;
        }
        else
        {
          this.searchParams.RecieptType = 0;
        }
          
          this.searchParams.CashAccountingCodeID = this.CashAccountingCodeID.CodeID;
           
          this.searchParams.PreView = false;
          this.searchParams.SourceCompanyID = this.seciliCariFirma;
          this.$http
            .post(
              auth.API_URL +
                "api/AccountingIntegrations/IntegrationRecieptCreateHtml",
              this.searchParams,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                this.loadingvmodel = false;
                this.entegreDialog = false;
                this.dialogTemplate = true;
                var w = window.innerWidth;
                var iframe = document.getElementById("result");

                document.getElementById("result").srcdoc = response.body;
                if (w <= 480) {
                  iframe.style = "width:400;height:200px;";
                } else if (w <= 768) {
                  iframe.style = "width:700px;height:500px;";
                } else if (w <= 1024) {
                  iframe.style = "width:1000px;height:500px;";
                } else {
                  iframe.style = "width:1200px;height:200px;";
                }
                var blob = new Blob([response.body], {
                  type: "application/html",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "MuhasebeCariEntegre.html";
                link.click();
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable-IntegrationTemplateDelete";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                  this.entegreDialog = false;
                } else {
                  this.text1 = "Service Unavailable-IntegrationTemplateDelete";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                  this.entegreDialog = false;
                }
              }
            );
        }
      }
    },
    getPreeView() {
      if (this.$refs.formEntegre.validate()) {
        var bastarih = new Date(this.searchParams.StartDate);
        var bittarih = new Date(this.searchParams.EndDate);

        if (this.searchParams.DocTypeCode==null)
        {
          this.searchParams.DocTypeCode="";
        }
        if (this.ExpenseCenter==null || this.ExpenseCenter=="undefined")
        {
          this.searchParams.CostCenterCode="";
        }
        else
        {
          this.searchParams.CostCenterCode=this.ExpenseCenter;
        }
        if (bastarih <= bittarih) {
          this.loadingvmodel = true;

         
          this.searchParams.AccountingCompanyID = this.seciliMuhasebeFirma;
           
          this.searchParams.UserID = this.credentials.UserID;
          this.searchParams.AccountingCenter = this.CenterCode.ID;
          if (this.RecieptType!=null)
        {
          this.searchParams.RecieptType = this.RecieptType.ID;
        }else
        {
          this.searchParams.RecieptType = 0;
        }
          
          this.searchParams.CashAccountingCodeID =
          this.CashAccountingCodeID.CodeID;
          this.searchParams.PreView = true;
          this.searchParams.SourceCompanyID = this.seciliCariFirma;
          this.searchParams.CompanyID=this.credentials.MuhasebeSirketNo;
          this.$http
            .post(
              auth.API_URL +
                "api/AccountingIntegrations/IntegrationRecieptCreateHtml",
              this.searchParams,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                this.loadingvmodel = false;
                this.preViewDialog = false;
                this.dialogTemplate = true;
                var w = window.innerWidth;
                var iframe = document.getElementById("result");

                document.getElementById("result").srcdoc = response.body;
                if (w <= 480) {
                  iframe.style = "width:380px;height:200px;";
                } else if (w <= 768) {
                  iframe.style = "width:700px;height:500px;";
                } else if (w <= 1024) {
                  iframe.style = "width:900px;height:500px;";
                } else {
                  iframe.style = "width:1200px;height:200px;";
                }
                var blob = new Blob([response.body], {
                  type: "application/html",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "MuhasebeCariEntegre.html";
                link.click();
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 =
                    "Service Unavailable-IntegrationRecieptCreateHtml";
                  this.snackbar = true;
                  this.preViewDialog = false;
                  this.loadingvmodel = false;
                } else {
                  this.text1 =
                    "Service Unavailable-IntegrationRecieptCreateHtml";
                  this.snackbar = true;
                  this.preViewDialog = false;
                  this.loadingvmodel = false;
                }
              }
            );
        }
      }
    },
    goDetailPage(id) {
      var url = "#/entegrasyon/biletentdetail/id?" + "id=" + id;
      window.open(url, "_blank");
    },
    findTemplateTicketTypeName(kod) {
      if (kod === undefined) return "";

      let ticket = this.ticketType.find((x) => x.value == kod);
      return ticket.text;
    },
    findTemplateTypeName(kod) {
      if (kod === undefined) return "";

      let template = this.templateType.find((x) => x.value == kod);
      return template.text;
    },
    getList() {
      this.loadingvmodel = true;
      let params = {
        TemplateID: 0,
        CompanyID: this.credentials.MuhasebeSirketNo,
        TemplateType: 0,
        TemplateTicketType: 0,
        TemplateName: null,
        LineList: [],
      };

      this.$http
        .post(
          auth.API_URL + "api/AccountingIntegrations/IntegrationTemplateList",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.itemsTemplate = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihim,
    merkez,
    fistipi,
    catimuhasebekodu,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
   
  
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      this.getList();
      this.getEvrakTipi();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};
</script>

<style>
</style>

